import { React } from "react";
import { ProgressBar, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import "../../../assets/stlyes/BigPicture/EOYP.scss";
import { Common } from "../../../helper";

const EOYP_ProgressBar = (props) => {
  const { subject } = props;
  const TestData = (key) => {
    return (key === "B" ? "danger" : key === "W" ? "warning" : key === "E" ? "success" : key === "G" ? "info" : "#FFF")
  };

  const Styles = {
    tooltipMain: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row"
    },
    tooltipContentContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  }

  const renderTooltip = (item) => (
    <Tooltip>
      <div style={Styles.tooltipContentContainer}>
        <div style={Styles.tooltipMain}><div className="greenPointer_" style={{ backgroundColor: "var(--below-color)" }} />&nbsp;{`${Common.BLW}: ${item.B}`}</div>
        <div style={Styles.tooltipMain}><div className="greenPointer_" style={{ backgroundColor: "var(--emerging-colour)" }} />&nbsp;{`${Common.WTS}: ${item.W}`}</div>
        <div style={Styles.tooltipMain}><div className="greenPointer_" style={{ backgroundColor: "var(--expected-color)" }} />&nbsp;{`${Common.EXS}: ${item.E}`}</div>
        <div style={Styles.tooltipMain}><div className="greenPointer_" style={{ backgroundColor: "var(--greater-color)" }} />&nbsp;{`${Common.GDS}: ${item.G}`}</div>
      </div>
    </Tooltip>
  );

  return (
    <div className="EOYP-ProgressBar">
      {Object.values(subject).filter(Array.isArray)[0].map((item, i) => (<Row key={i}>
        <Col sm={3}>
          <span className="ProgressBar-title">{`${item.name} (${item.totalCount})`}</span>
        </Col>
        <Col sm={9}>
          <OverlayTrigger placement="top" overlay={renderTooltip(item?.value)}>
            <ProgressBar className="progressBarMain">
              {Object.entries(item.value).map(([key, value], j) => (<ProgressBar variant={TestData(key.toUpperCase())} key={j} now={parseInt(value)} label={`${value}`} />))}
            </ProgressBar>
          </OverlayTrigger>
        </Col>
      </Row>))}
    </div>
  )
}

export { EOYP_ProgressBar }